module.exports = __webpack_public_path__ + "img/icon-right.c05ebc44.svg";